/**
 * @file 各画面共通の加盟員検索モーダルのインスタンスを生成
 */
'use strict'

/**
 * @classname CommonMemberSearchModal
 * @classdesc 各画面共通の加盟員検索モーダルのインスタンスを生成
 */
export default class CommonMemberSearchModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('#modal-common-member-search')
	 * @param {instance} controller
	 */
	constructor($e, controller) {
		console.log(`CommonMemberSearchModal.constructor`)
		this._$e = $e
		this._controller = controller
		this._element = document.getElementById('modal-common-member-search')
		this._Modal = new bootstrap.Modal(this._element)
		this.initialize()
	}


	/**
	 * Initialize
	 *
	 * @memberof CommonMemberSearchModal
	 * @return {undefined}
	 */
	initialize() {
		console.log(`CommonMemberSearchModal.initialize`)
		if (!this._$e.data('show-council')) this._$e.find('.council-id-wrap').addClass('d-none').find('.council_id').addClass('ignore-search')
		if (!this._$e.data('show-district'))this._$e.find('.district-id-wrap').addClass('d-none').find('.district_id').addClass('ignore-search')
		if (!this._$e.data('show-group')) this._$e.find('.group-id-wrap').addClass('d-none').find('.group_id').addClass('ignore-search')
	}
}
